<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal15" :class="type == 2 ? 'modal-mask' : 'modal-mask1'" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop  style="max-width: 100%;">
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"  style="color: #6c757d !important;"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png"  />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body"  style="min-height: 700px;">
              <div class="modal_reps_to_review d-none-">

                <div class="row mb-2 mt-3">
                  <div class="col-6 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">{{ menteeShortName }}</div>
                    <button class="text-uppercase btn btn-primary d-none mentee_title_btn">Apprentice</button>
                  </div>
                  <div class="col-6 pr-4 text-right">
                    <div class="text-muted">Mentor(s)</div>
                    <ul class="list-inline">
                      <li class="list-inline-item font-weight-bold" v-for="(mentorAssigned, index) in mentorsAssigned" :key="index">{{ mentorAssigned.name }}</li>
                    </ul>                
                  </div>              
                </div>

                <div>
                  <div class="mt-1 mb-3 pl-3 pr-3">
                    <div class="row align-items-end">
                      <div class="col px-2 text-center" v-for="(pathwayStep, index) in pathwayStepsData.mentee_pathway_steps">
                        <p class="text-uppercase mb-1 " 
                          :class="activeStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" >
                          <span :style="activeStep == pathwayStep.id ? 'background-color: ' + pathwayStepsData.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
                        </p>
                        <div class="progress progress_pathway">
                          <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
                        </div>
                      </div>        
                    </div>
                  </div>
                </div>


                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="success"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                  >
                  {{ success_message }}
                </b-alert>

                <div class="row align-items-center mb-3">
                  <div class="col-12" style="padding-right: 15px;">
                    <div class="px-2">
                      <div class="input-group search_tasks_txtbox">
                        <input type="text" class="form-control" placeholder="Search Certifications" v-model="searchText" aria-label="Search tasks" @keyup.enter="dosearch()" />
                        <div class="input-group-append">
                          <span class="input-group-text" v-if="searchTextFlag"><i class="fa fa-close" aria-hidden="true" @click="clearText()"></i></span>
                          <span class="input-group-text" v-else><i class="fa fa-search" aria-hidden="true" @click="dosearch()"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


    <div class="row mb-3 align-items-end border-bottom mx-2 pb-2">
      <div class="col-6 pl-0">
        <div class=" h4 mb-0">Certifications</div>
      </div>
      <div class="col-6 pr-0 text-right">
        <div class="text-muted small"></div>
      </div>
    </div>

                <div style="margin-bottom: 7px; float: left; width: 100%;" v-if="loading == true">

                  <div class="row pb-2 mx-2 mb-2 border-class" style="border-bottom: 1px solid #CCC;" v-for="option in 3">
                    <div class="col-1" style="padding-left: 0px;">
                      <PuSkeleton circle height="45px" width="45px"  :count="1"></PuSkeleton>
                    </div>

                    <div class="col-7 col-xl-8 pt-1 pl-3" >
                      <div class="col-8 p-0">
                      <PuSkeleton :count="2"></PuSkeleton>
                      </div>
                    </div>
                    <div class="col-4 col-xl-3 text-right pt-3" style="padding-left: 0px; padding-right: 0px;" >
                      <PuSkeleton :count="1"></PuSkeleton>
                    </div>
                  </div>
                  
                </div>


    <div class="mentee-progress-list" v-if="certificates.length == 0 && loading == false">
      <div class="row" style="">
        <div class="col-11" style="padding-left: 25px; font-style: italic;">
          No certification found
        </div>
      </div>      
    </div>


    <div class="mentee-progress-list">
    <div class="border-class mb-3 align-items-center ml-3 pr-3 pb-2" v-for="(item, index) in certificates">
    <div class="row" style="">
      <div class="col-1" style="padding-left: 5px;">
        <div class="progress-circle" >
          <img :src="item.image" width="50px" />
        </div>
      </div>

      <div class="col-7 col-xl-8 pt-1 pl-3" >
        <p class="mb-0">{{ item.name }}</p>
        <p class="small text-muted mb-0" v-if="item.menteeCertificateExpires">Certification - {{ item.menteeCertificateExpires }}</p>
      </div>
      <div class="col-4 col-xl-3 text-right pt-2" style="padding-left: 0px; padding-right: 5px;" v-if="(item.buttonName == 'Upload Certification' && checkIsManager())">
        <a class="progress_item_link font-weight-bold" @click="uploadCertificationModalOpen(item.id, item.stepObjectiveId)"> {{ item.buttonName }}
          <img class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
      <div class="col-4 col-xl-3 text-right pt-2" style="padding-left: 0px; padding-right: 5px;" v-if="(item.buttonName == 'Approve Certification' && checkIsManager())">
        <a class="progress_item_link font-weight-bold" @click="approveCertificationModalOpen(item.id, item.stepObjectiveId)"> {{ item.buttonName }}
          <img class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
      <div class="col-4 col-xl-3 text-right pt-2" style="padding-left: 0px; padding-right: 5px;" v-if="item.buttonName == 'View Certificate'">
        <a class="progress_item_link font-weight-bold" @click="downloadFunc(item.menteeCertificatename)"> {{ item.buttonName }}
          <img class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
    </div>
    </div>
    </div>



              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>


    <div v-if="isMenteeUploadComponentVisible">
    <MenteeUploadCertificate 
      :isModalVisible="isMenteeUploadComponentVisible"
      :type="type"
      @close="uploadCertificationModalClose"
      @closeMenteeUploadModal="uploadCertificationModalClose"
      ref="MenteeUploadModal">
    </MenteeUploadCertificate>
    </div>

    <div v-if="isMenteeApproveComponentVisible">
    <MenteeApproveCertificate 
      :isModalVisible="isMenteeApproveComponentVisible"
      :type="type"
      @close="approveCertificationModalClose"
      @closeMenteeApproveModal="approveCertificationModalClose"
      ref="MenteeApproveModal">
    </MenteeApproveCertificate>
    </div>


  </div>
</template>

<script>
import axios from 'axios';
import MenteePathwayProgress from '@/components/manager/mentee_pathway_progress.vue';
import MenteeUploadCertificate from '@/components/manager/mentee_upload_certificate.vue';
import MenteeApproveCertificate from '@/components/manager/mentee_approve_certificate.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';


export default {
  props: ['isModalVisible', 'type'],
  data() {
    return {
      menteeFirstName: '',
      menteeShortName: '',
      repCount: '',
      repTasks: '',
      mentorsAssigned: [],
      viewAll: false,
      searchText: '',
      subtasks: [],
      focusedSubtasks: [],
      searchTextFlag: false,
      menteeId: '',
      certId: '',
      isMenteeUploadComponentVisible: false,
      isMenteeApproveComponentVisible: false,
      success_message: '',
      dismissCountDown: 0,
      menteePathway: {},
      stepId: '',
      progress: [],
      certificates: [],
      searchText: '',
      loading: false,
      pathwayStepsData: [],
      activeStep: '',
    }
  },
  computed: {
    
  },
  methods: {
        checkIsMentor() {
            return checkIsMentor();
        },
        checkIsManager() {
            return checkIsManager();
        },
    downloadFunc: function(fileName) {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/certificates/' + fileName;
      window.open(url, '_blank');
      return false;    
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    toggleViewAll() {
      this.viewAll = !this.viewAll;
    },
    hide() {
      this.$emit('closeTaskListModal');
    },
    clearText() {
      this.searchText = '';
      this.loading = true;
      this.searchTextFlag = false;
      this.getMenteeCertificatesData(this.menteeId, this.certId, this.stepId);
    },
    approveCertificationModalOpen(certId, stepObjectiveId) {
      this.isMenteeApproveComponentVisible = true;
      setTimeout(() => { 
      this.$refs.MenteeApproveModal.getMenteeCertificatesData(this.menteeId, certId, this.currentStepId, stepObjectiveId);
      }, 500);
    },
    approveCertificationModalClose() {
      this.getMenteeCertificatesData(this.menteeId, this.certId, this.stepId);
      this.isMenteeApproveComponentVisible = false;
    },
    uploadCertificationModalOpen(certId, stepObjectiveId) {
      this.isMenteeUploadComponentVisible = true;
      setTimeout(() => { 
      this.$refs.MenteeUploadModal.getMenteeCertificatesData(this.menteeId, certId, this.currentStepId, stepObjectiveId);
      }, 500);
    },
    uploadCertificationModalClose() {
      this.getMenteeCertificatesData(this.menteeId, this.certId, this.stepId);
      this.isMenteeUploadComponentVisible = false;
    },
    dovalidate() {
      var flag = 1;
      if(this.searchText == '') {
        alert("Please enter search text");
        flag = 0;
        return false;
      }
      if(this.searchText.length < 3) {
        alert("Search text should be minimum 3 characters");
        flag = 0;
        return false;
      }
      return flag;
    },
    dosearch() {
      var flag = this.dovalidate();
      if(flag == 1) {
        this.certificates = [];
        this.loading = true;
        axios('/desktop/v2/get-mentee-certification-details-step', {
          method: 'GET',
          params: {
            certId: this.certId,
            accountId: this.$store.state.user_accountid, 
            stepId: this.stepId, 
            menteeId: this.menteeId,
            searchText: this.searchText,
          }
        })
        .then(resp => {
          this.loading = false;
          this.certificates = resp.data.certificates;
          this.searchTextFlag = true;
        })
        .catch(() => {});
      }
    },
    getMenteeCertificatesData(menteeId, certId, stepId) {
      this.menteeId = menteeId;
      this.loading = true;
      this.certId = certId;
      this.stepId = stepId;
      this.certificates = [];

      axios('/desktop/get-mentee-repitition-lists-all-tasklists', {
        method: 'GET',
        params: {
          mentee_id: this.menteeId,
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.menteeFirstName = data.mentee_first_name;
        this.menteeShortName = data.mentee_short_name;
        this.repCount = data.rep_count;
        this.repTasks = data.rep_tasks;
        this.mentorsAssigned = data.mentors_assigned;
      })
      .catch(() => {});

      axios('/desktop/v2/pathway/get-mentee-pathway-progress', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: this.menteeId, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.pathwayStepsData = data;
        this.activeStep = this.pathwayStepsData.mentee_pathway.currentStep;
        this.pathwayId = this.pathwayStepsData.mentee_pathway.id;
        this.showFutureSteps = this.pathwayStepsData.mentee_pathway.showFutureSteps;
      })
      .catch(() => {});


      axios('/desktop/v2/get-mentee-certification-details-step', {
        method: 'GET',
        params: {
          certId: this.certId,
          accountId: this.$store.state.user_accountid, 
          stepId: this.stepId, 
          menteeId: this.menteeId,
        }
      })
      .then(resp => {
        this.loading = false;
        this.certificates = resp.data.certificates;
      })
      .catch(() => {});
      
      setTimeout(() => {
        let element = document.getElementById('groupModal15');    
        element.scrollIntoView(true);
      }, 2000); 
    }
  },
  components: {
    MenteePathwayProgress,
    MenteeUploadCertificate,
    MenteeApproveCertificate,
  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}

a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}

::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
a {
  color: #00acee !important;
}
a:hover,
a:active,
a:focus {
  color: #00acee !important;
}
@media (max-width: 1199.98px) {
  .progress_item_link {
    font-size: 13px;
    cursor: pointer;
  }
}
.progress_item_link {
  cursor: pointer;
}
.objective-view-icon {
  width: 15px;
  margin-left: 2px !important;
}
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
}
.search_tasks_txtbox input:active,
.search_tasks_txtbox input:focus,
.search_tasks_txtbox input:hover {
  border-color: #ced4da !important;
}
.search_tasks_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}
.progress_bar_100 {
  background-color: #00acee !important;
}

</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_certifications.vue